import React from 'react';
import { useTranslation } from 'react-i18next';
import Button from '../Form/Button';
import HandX from './Icons/HandX';

interface NotifySwiperCategoryProps {
    show: boolean;
    onClickConfirm?: CallableFunction;
    classNameIcon?: string;
}

const NotifySwiperCategory = ({
    show,
    onClickConfirm = () => {},
    classNameIcon
}: NotifySwiperCategoryProps) => {

    const { t } = useTranslation();

    if (!show) return null;

    return (
        <div
            onClick={() => onClickConfirm()}
            className='fixed inset-0 p-6 z-100 zoomInIcon grid items-center cursor-pointer bg-gray-800/85 backdrop-blur-sm text-white'
            >
                <div className='flex flex-col items-center gap-4'>

                    <HandX className={`${classNameIcon}`} />

                    <div className='flex flex-col gap-6 text-center'>
                        <span className='text-xl font-extrabold leading-none mx-8'>{t('products.next_category_drag_title')}</span>
                        <div className='w-full flex justify-center items-center text-lg'>
                            <Button outline onClick={() => onClickConfirm()} className="w-auto ring-2 ring-white text-white">{t('products.next_category_button_label')}</Button>
                        </div>
                    </div>
            </div>
        </div>
    )
}

export default NotifySwiperCategory;